<span *ngIf="status === outputStatus.Open && !showOnlyText" [ngClass]="{'light-theme-icon': (isDarkTheme$ | async) === (false || null || undefined)}"
      class="icon-open"></span>
<span *ngIf="status === outputStatus.Open && !showOnlyIcons">Opened</span>
<span *ngIf="status === outputStatus.Closed && !showOnlyText" [ngClass]="{'light-theme-icon': (isDarkTheme$ | async) === (false || null || undefined)}"
      class="icon-closed"></span>
<span *ngIf="status === outputStatus.Closed && !showOnlyIcons">Closed</span>
